import { ApiService } from "@/api";

export default {
  FETCH_SIDE_TASK_TYPES({ commit }) {
    return ApiService.sideTaskTypes.fetchList().then((res) => {
      commit("SET_SIDE_TASK_TYPES", res);
    });
  },
};
